import styled from "@emotion/styled";

export const PageNotAvailableContent = styled.div`
  background: ${({ theme }) => theme.surface};
  padding: 2rem;
  margin: 16vh 20vw 20vh;
  max-width: 600px;
  text-align: center;
  border-radius: 15px;
  border: 1px solid ${({ theme }) => theme.outlineSoft};

  > p {
    font-size: ${({ theme }) => theme.fontSizeLarge};
    margin: 25px 0;
  }
`;
